import { ForgotPassword } from "components/views/ForgotPassword";
import { ResetPassword } from "components/views/ResetPassword";
import { SignIn } from "components/views/SignIn";
import { SignUp } from "components/views/SignUp";
import { FORGOT_PASSWORD_ROUTE, RESET_PASSWORD_ROUTE, SIGN_IN_ROUTE, SIGN_UP_ROUTE } from "constants/routesValues";

export const CONFIG_ROUTES: Record<string, JSX.Element> = {
  [SIGN_IN_ROUTE]: <SignIn />,
  [SIGN_UP_ROUTE]: <SignUp />,
  [FORGOT_PASSWORD_ROUTE]: <ForgotPassword />,
  [RESET_PASSWORD_ROUTE]: <ResetPassword />,
};
